/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** abr-webchat OIDC 入口（5050 代理到后端 /oauth/oidc/login） */
export const AI_QUERY_OIDC_DEFAULT_RETURN_PATH = '/oauth/oidc/login';

/** Coze Agent 调试/分享统一入口 */
export const COZE_CHAT_ENTRY_PATH = '/chat/agent';

/** IdP 桥接页 postMessage：子页就绪 */
export const AI_QUERY_BRIDGE_MSG_READY = 'tology-idp-bridge-ready';

/** IdP 桥接页 postMessage：父页下发 UC userkey */
export const AI_QUERY_BRIDGE_MSG_TOKEN = 'tology-idp-bridge';

export const AI_QUERY_BRIDGE_HANDSHAKE_MS = 12_000;

export const ABR_CHAT_FRAME_STORAGE_KEY = 'coze-use-abr-chat-frame';

export const SESSION_USERKEY = 'userkey';
